import { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import useUrlInfo from '../urls/useUrlInfo';
import useLog from '../log/useLog';
import { GET_CALLBACK_URL_VALIDATION } from './queries/GET_CALLBACK_URL_VALIDATION';
import { GenericErrorStatus } from '../../../../types/errors/ErrorStatus';

export enum CallbackUrlValidationStatus {
  NOT_WHITELISTED = 'NOT_WHITELISTED',
  NO_CONFIG = 'NO_CONFIG',
  WHITELISTED = 'WHITELISTED',
}

export interface GetCallbackUrlValidationResponse {
  getCallbackUrlValidation: {
    status: CallbackUrlValidationStatus;
    message: string;
  };
}
export interface GetCallbackUrlValidationRequest {
  pid: string;
  url: string;
}
const useGetCallbackUrlValidationLazyQuery = () => {
  const { pid, requestId } = useUrlInfo().states;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { logError } = useLog().actions;

  const [getCallbackUrlValidation] = useLazyQuery<GetCallbackUrlValidationResponse, GetCallbackUrlValidationRequest>(
    GET_CALLBACK_URL_VALIDATION,
  );

  const fetchGetCallbackUrlValidation = async (url: string) => {
    const variables = {
      pid,
      url,
    };
    setLoading(true);
    const { data, error } = await getCallbackUrlValidation({
      variables,
    });
    if (error) {
      setError(error.message);
      logError(GenericErrorStatus.APOLLO_ERROR, {
        pid,
        requestId,
        query: 'useGetCallbackUrlValidationLazyQuery',
        error: error.message,
      });
    }
    setLoading(false);
    return data?.getCallbackUrlValidation.status;
  };

  return {
    actions: {
      fetchGetCallbackUrlValidation,
    },
    states: {
      loading,
      error,
    },
  };
};

export default useGetCallbackUrlValidationLazyQuery;
